<template>
    <a-modal
    title="付款通知书"
    v-model="modalShow"
    width="80%"
    :footer="null"
    destroyOnClose>
        <div style="padding-bottom:40px">
            <div class="contract-box" v-html="artcCntnt">
            </div>
        </div>
    </a-modal>
</template>

<script>
import {getGoldTicketInfo,PymNoticeFileSeen} from "@/api/buyrPym.js"
export default {
    props:{
        info:{
            type:Object,
            default:function(){
                return {};
            }
        }
    },
    components: {},
    data() {
        return {
            modalShow:false,
            artcCntnt:""
        };
    },
    computed: {},
    methods: {
        open(){
            this.modalShow = true;
            this.getGoldTicketInfo();
        },
        close(){
            this.modalShow = false;
        },
        getGoldTicketInfo(){
            if(this.info && this.info.gldId){
               let param = {
                    gldId:this.info.gldId,
                    tenantId:this.info.tenantId,
                };
                getGoldTicketInfo(param).then(res => {
                    this.artcCntnt = res.data.pymNoticeFile;
                    PymNoticeFileSeen({id:res.data.id,seenStCd:1}).then(resSeen => {

                    })
                }) 
            }
            
        }
    },
    created() {},
    mounted() {},
    watch:{
        info(newVal){
            this.getGoldTicketInfo();
        }
    }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/bill-payment/pay-notice.vue